import Rx from 'rxjs';
import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as errorActions from 'modules/error/action';
import * as generalActions from 'modules/general/action';
import * as asignacionActions from 'modules/asignacion/action';
import * as viajesActions from 'modules/viajes/action';

import { request } from 'core/generalFunctions';

const { ajax } = Rx.Observable;

export const asignarEpic = (action$, store) =>
action$
.ofType(constAction.ASIGNACION_ASIGNAR)
.switchMap(action => {
  let storeState = store.getState(),
  diaBuscando = storeState.getIn(['viajes', 'diaBuscando']),
  endAction = diaBuscando ? viajesActions.buscar(diaBuscando) : viajesActions.get();

  if(!action.payload.viajeId) action.payload.viajeId = storeState.getIn(['asignaciones', 'viajeId']);
  if(!action.payload.viajeId) return Rx.Observable.of(generalActions.snackbar_show('Ha ocurrido un error, intente nuevamente en unos instantes.'))
  return ajax(request(action))
  .mergeMap(() => [asignacionActions.clear('viajeId'), endAction])
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()));
});

export const buscarVehiculoEpic = (action$, store) =>
action$
.ofType(constAction.ASIGNACION_SELECCIONAR_VEHICULO)
.switchMap(action => ajax(request(action))
  .map(({response}) => generalActions.seleccionador_setLista('vehiculos', response))
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()))
);

export default combineEpics(asignarEpic, buscarVehiculoEpic);



// WEBPACK FOOTER //
// src/modules/asignacion/epics.js